/*
 * コンサル側 広告 一覧取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_PROFESSIONAL_AD = 'API_GET_LIST_PROFESSIONAL_AD';
/**
 * 一覧取得
 */
export const apiGetListProfessionalAd = (_, meta) => apiGetList(API_GET_LIST_PROFESSIONAL_AD, '/professional/ad', {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
